import { gql } from "graphql-request";
import graphqlClient from "./graphqlClient";

export interface StripePaymentMethod {
  id: string;
  object: string;
  allow_redisplay: string;
  billing_details: {
    address: {
      city: string | null;
      country: string | null;
      line1: string | null;
      line2: string | null;
      postal_code: string | null;
      state: string | null;
    };
    email: string | null;
    name: string | null;
    phone: string | null;
    tax_id: string | null;
  };
  card: {
    brand: string;
    checks: {
      address_line1_check: string | null;
      address_postal_code_check: string | null;
      cvc_check: string | null;
    };
    country: string;
    display_brand: string;
    exp_month: number;
    exp_year: number;
    fingerprint: string;
    funding: string;
    generated_from: any | null;
    last4: string;
    networks: {
      available: string[];
      preferred: string | null;
    };
    regulated_status: string;
    three_d_secure_usage: {
      supported: boolean;
    };
    wallet: any | null;
  };
  created: string;
  customer: string;
  livemode: boolean;
  metadata: Record<string, any>;
  radar_options: Record<string, any>;
  type: string;
}

export interface PaymentMethodsData {
  defaultStripePaymentMethodId: string;
  stripePaymentMethods: StripePaymentMethod[];
}

export interface GetStripePaymentMethodsResponse {
  getStripePaymentMethods: PaymentMethodsData;
}

const GET_STRIPE_PAYMENT_METHODS = gql`
  query GetStripePaymentMethods {
    getStripePaymentMethods
  }
`;

export async function getStripePaymentMethods(token?: string | null): Promise<PaymentMethodsData> {
  const response = await graphqlClient.request<GetStripePaymentMethodsResponse>(
    GET_STRIPE_PAYMENT_METHODS,
    undefined,
    token,
  );
  return response.getStripePaymentMethods;
}
